import { defineComponent, h } from 'vue';
import BaseComponent from './BaseComponentMixin.jsx';
import EventBus from '../event-bus.js';
import { QToggle } from 'quasar';

import TranslationContainer from './TranslationContainer.jsx';

import utils from '../../Shared/utils.jsx';
import methods from '../../Shared/methods';
import { normalizeTooltipPlacementKey } from '../../Shared/buttonAppearance.js';

export default defineComponent({
    name: 'basic-toggle',
    mixins: [BaseComponent],
    components: {
        TranslationContainer,
        QToggle,
    },
    data: function () {
        return {
            defaultEval: null,
            colorEval: null,
            tooltipEval: null,
            tooltipLocationEval: null,
            isDisabledEval: null,
            classEval: null,
            value: false
        }
    },
    props: {},
    created() {
        this.value = (utils.evaluate(utils.compile(this, this.controlData.Default), this) == 'true');
    },
    //Mounted Replaced with preRenderComplete
    computed: {
        ToggleState() {
            return this.value;
        },
        SwitchState() {
            return this.value;
        },
        label() {
            if(this.value) 
                return this.controlData.OnLabel ? this.controlData.OnLabel : ''
            else
                return this.controlData.OffLabel ? this.controlData.OffLabel : ''
        },
        color() {
            try {
                let theColor = 'primary';
                if(this.colorEval === null && this.controlData.OnColor)
                    this.colorEval = utils.compile(this, this.controlData.OnColor);
                if(this.colorEval)
                    theColor = utils.evaluate(this.colorEval, this);
                
                theColor = theColor || 'primary'
                
                // This helps with backwards compatibility for a version of Bootstrap that used the word 'default' to describe the secondary button
                if(theColor === 'default')
                    return 'secondary';
                else if(theColor === 'danger')
                    return 'error';
                return theColor;
            }
            catch (e) {
                utils.warn('Color could not evaluate expression: ' + this.controlData.OnColor + '; ' + e);
                return 'primary';
            }
        },
        tooltip() {
            try {
                if(this.tooltipEval === null && this.controlData.Tooltip)
                    this.tooltipEval = utils.compile(this, this.Translate(this.controlData.Tooltip));
                if(this.tooltipEval)
                    return utils.evaluate(this.tooltipEval, this);
                return '';
            }
            catch (e) {
                utils.warn('Tooltip could not evaluate expression: ' + this.controlData.Tooltip + '; ' + e);
                return '';
            }
        },
        tooltipLocation() {
            try {
                if(this.tooltipLocationEval === null && this.controlData.TooltipLocation)
                    this.tooltipLocationEval = utils.compile(this, this.Translate(this.controlData.TooltipLocation));
                if(this.tooltipLocationEval)
                    return normalizeTooltipPlacementKey(utils.evaluate(this.tooltipLocationEval, this));
                return 'top';
            }
            catch (e) {
                utils.warn('Tooltiplocation could not evaluate expression: ' + this.controlData.TooltipLocation + '; ' + e);
                return 'top';
            }
        },
        isDisabled() {
            try {
                if(this.isDisabledEval === null && this.controlData.IsDisabled)
                    this.isDisabledEval = utils.compile(this, this.Translate(this.controlData.IsDisabled));
                if(this.isDisabledEval)
                    return utils.evaluate(this.isDisabledEval, this) == 'true';
                return false;
            }
            catch (e) {
                utils.warn('IsDisabled could not evaluate expression: ' + this.controlData.IsDisabled + '; ' + e);
                return false;
            }
        },
        class() {
            try {
                if(this.classEval === null && this.controlData.Class)
                    this.classEval = utils.compile(this, this.Translate(this.controlData.Class));
                if(this.classEval)
                    return utils.evaluate(this.classEval, this).split('-')[0].toLowerCase() || 'top';
                return '';
            }
            catch (e) {
                utils.warn('Class could not evaluate expression: ' + this.controlData.Class + '; ' + e);
                return '';
            }
        }
    },
    methods: {
        async onChange(value) {
            this.value = value;
            await utils.executeAndCompileAllActions(this.controlData.Actions, { Value: value }, this);
        },
        preRenderComplete() {
            this.finishRenderHandler(this);
        },
        SetSwitchState(value) {
            this.value = value;
        },
        SetToggleState(value) {
            this.value = value;
        }
    },
    render() {
        if(!this.todisplay)
            return null;

        try {

            // v-slots required for a conditional slot object — a ternary as JSX
            // children is not treated as slots and stringifies to "[object Object]".
            let content = (
                <QToggle
                    dense
                    modelValue={this.value}
                    onUpdate:modelValue={this.onChange}
                    color={this.color}
                    class={{[this.class]: true, 'q-ma-xs': true}}
                    disable={this.isDisabled}
                    v-slots={this.label ? {
                        default: () => <TranslationContainer context={this} value={this.label}></TranslationContainer>
                    } : undefined}
                />
            );

            let finalContent = utils.generateTooltip(h, content, this.tooltip, this.tooltipLocation);

            return (
                <div class={{ 'c-BasicToggle': true, [`c-name-${this.name || 'unnamed'}`]: true }}
                    v-show={this.isvisible} style={this.sizeStyle}>
                    {finalContent}
                </div>
            );
        }
        catch(e) {
            utils.error('BasicToggle Render failed', e);
            return <div>BasicToggle Failed to Render {e}</div>;
        }
        
    }
});